import { useMemo } from "react";
import Fuse from "fuse.js";

const queryKeysMapping: any = {
  make: "make_name",
  model: "model_name",
  variant: "name"
};

// OPTIONS : included for future enhancmenent <--
const useFuseSearch = (data: any, searchQuery: any, query: any, options = {}): any => {
  console.log('make data rerender askdalskdnald', {data, query, searchQuery})
  // Determine the keys to search based on the query
  const keys = queryKeysMapping[query] ? [queryKeysMapping[query]] : ["name"];

  //? WARNING: Read this before changing threshold: https://www.fusejs.io/concepts/scoring-theory.html
  const defaultOptions = {
    keys: keys,
    threshold: 0.1, // Lower the value, stricter the match: (0.0 means perfect match of letters and location), 1.0 means any match is okay.
    includeScore: true,
    shouldSort: true,
    ...options // additional options for future enhancements
  };

  const fuse = useMemo(() => {
    try {
      return new Fuse(data, defaultOptions);
    } catch (error) {
      // todo: send alert to new-relic
      console.error("Error initializing Fuse:", error);
      return null;
    }
  }, [data, defaultOptions]);

  if (!fuse || !searchQuery) {
    return data;
  }

  const searchResults = fuse.search(searchQuery);
  // Sort the results by their score
  // searchResults.sort((a, b) => a?.score - b?.score);
  // Return the search results
  return searchResults.map((result) => result.item);
};

export default useFuseSearch;
